var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "2024px",
    height: "1139.9px",
    viewBox: "0 0 2024 1139.9",
    style: {
      enableBackground: "new 0 0 2024 1139.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F4F4F4;}\r\n\t.st1{fill:#BCBCBC;}\r\n\t.st2{fill:#DDDDDD;}\r\n\t.st3{fill:#C1C1C1;}\r\n\t.st4{fill:#353535;}\r\n\t.st5{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "\\uBC14\\uD0D5\\uC0C9_00000157998532247500259220000003612209341838017437_",
    className: "st0",
    d: "M2018.1,1134.3H5.9V5.9h2012.2V1134.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0C1\\uD0DC\\uBC14_00000001626952242653627730000014141366710332661433_",
    className: "st1",
    d: "M1981.8,171.9H40.4V40.4h1941.4V171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uBC84\\uD2BC\\uC0C9_00000181049449672005851660000016047636354076668606_",
    className: "st2",
    d: "M1646.9,60.1h91.8v91.8h-91.8V60.1z  M1757.6,60.1h91.8v91.8h-91.8V60.1z M1868.2,60.1h91.8v91.8h-91.8V60.1z M1349.6,703.8H670.5v213.5h679.1V703.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC911\\uAC04\\uD558\\uC774\\uB77C\\uC774\\uD2B8_00000098902113510877797470000011690544777865832381_",
    className: "st3",
    d: "M2023.9,0v9.5H9.5v1130.4H0 V0H2023.9z M665.2,924.6l9.7-7.9V706.1h672l7.9-9.7H665.2V924.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC9C4\\uD55C\\uC120_00000109024832074763850860000005146562239197380246_",
    className: "st4",
    d: "M1714.2,123.8h-42.8v-5h42.8V123.8z  M1900.6,121.8l13.3-13.3l13.4,13.4l3.6-3.6l-13.4-13.4l13.4-13.4l-3.6-3.6l-13.4,13.4L1900.6,88l-3.6,3.6l13.3,13.3l-13.3,13.3 L1900.6,121.8z M1823.6,123.9h-42.8V86h42.8V123.9z M1818.6,91H1786v27.7h32.6V91z M1961.4,58.5l-4.7,4.7v85.4h-85.4l-4.7,4.7h94.8 L1961.4,58.5L1961.4,58.5z M1740.2,58.5l-4.7,4.7v85.4h-85.4l-4.7,4.7h94.8L1740.2,58.5L1740.2,58.5z M2014.5,9.5v1121H9.5L0,1140 h2024V0L2014.5,9.5z M1850.8,58.5l-4.7,4.7v85.4h-85.4l-4.7,4.7h94.8L1850.8,58.5L1850.8,58.5z M1354.8,696.4l-9.7,9.7V915H674.9 l-9.7,9.7h689.6V696.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD558\\uC774\\uB77C\\uC774\\uD2B8_00000143610753370212534750000007307876381323990412_",
    className: "st5",
    d: "M1649.9,63.5v85.4l-4.7,4.7V58.7 h94.8l-4.7,4.7L1649.9,63.5L1649.9,63.5z M1755.8,153.6l4.7-4.7V63.5h85.4l4.7-4.7h-94.8L1755.8,153.6L1755.8,153.6z M1866.4,153.6 l4.7-4.7V63.5h85.4l4.7-4.7h-94.8L1866.4,153.6L1866.4,153.6z M9.5,9.5v1120.9l4.5-4.3V14.2h1995.5l5-4.7H9.5z M674.9,710.3v4 v200.8l8.2-7.8v-193H1337l8.2-8H674.9V710.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.edfae5e5a4d84b09a2af501cd6b210a0.svg";
export { ForwardRef as ReactComponent };